export const ChatState = {
    ACTIVE: "ACTIVE",
    BLOCKED: "BLOCKED"
} as const;
export type ChatState = (typeof ChatState)[keyof typeof ChatState];
export const PaymentStatus = {
    WAITING: "WAITING",
    PAID: "PAID",
    CANCELED: "CANCELED"
} as const;
export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];
export const PaymentType = {
    PAYMENT: "PAYMENT",
    WITHDRAW: "WITHDRAW"
} as const;
export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType];
export const TonWalletStatus = {
    ACTIVE: "ACTIVE",
    DISABLED: "DISABLED"
} as const;
export type TonWalletStatus = (typeof TonWalletStatus)[keyof typeof TonWalletStatus];
export const EAction = {
    CHECK: "CHECK",
    FOLD: "FOLD",
    BET: "BET",
    RAISE: "RAISE",
    CALL: "CALL",
    ALL_IN: "ALL_IN"
} as const;
export type EAction = (typeof EAction)[keyof typeof EAction];
export const EPlayerStatus = {
    RESERVE: "RESERVE",
    PAYMENT: "PAYMENT",
    AWAIT_BB: "AWAIT_BB",
    PLAY: "PLAY",
    IDLE: "IDLE",
    LEAVING: "LEAVING"
} as const;
export type EPlayerStatus = (typeof EPlayerStatus)[keyof typeof EPlayerStatus];
export const ERound = {
    DEAL: "DEAL",
    PRE_FLOP: "PRE_FLOP",
    FLOP: "FLOP",
    TURN: "TURN",
    RIVER: "RIVER",
    SHOWDOWN: "SHOWDOWN"
} as const;
export type ERound = (typeof ERound)[keyof typeof ERound];
export const ETableType = {
    PUBLIC: "PUBLIC",
    PRIVATE: "PRIVATE"
} as const;
export type ETableType = (typeof ETableType)[keyof typeof ETableType];
export const EGameType = {
    NLH: "NLH",
    PLO4: "PLO4",
    PLO5: "PLO5"
} as const;
export type EGameType = (typeof EGameType)[keyof typeof EGameType];
export const ECurrency = {
    TON: "TON",
    USDT: "USDT",
    COIN: "COIN",
    TOKEN: "TOKEN",
    USD: "USD",
    EUR: "EUR",
    GBP: "GBP",
    JPY: "JPY",
    CNY: "CNY",
    INR: "INR",
    BRL: "BRL",
    RUB: "RUB",
    AED: "AED",
    NONE: "NONE"
} as const;
export type ECurrency = (typeof ECurrency)[keyof typeof ECurrency];
export const ETransactionType = {
    BUY_IN: "BUY_IN",
    CASH_OUT: "CASH_OUT",
    REWARD: "REWARD"
} as const;
export type ETransactionType = (typeof ETransactionType)[keyof typeof ETransactionType];
export const EQuestStatus = {
    ACTIVE: "ACTIVE",
    REWARDED: "REWARDED"
} as const;
export type EQuestStatus = (typeof EQuestStatus)[keyof typeof EQuestStatus];
